export enum FlowStepTypes {
  MENU = 'menu',
  ACTION = 'action',
  NEW = 'new',
  FLOW = 'flow',
  START = 'start',
  INTEGRATION = 'integration',
}

export enum MenuTypes {
  ASKINPUT = 'askInput',
  DISPLAYMENU = 'displayMenu',
  MENUOPTION = 'menuOption',
  MULTIPLECHOICE = 'multipleChoice',
  EXTERNALLINK = 'externalLink',
  PAYMENT = 'payment',
  AGENTHANDOFF = 'touch',
  MEDIA = 'media',
  CHATDESK = 'chatdesk',
  RICHLINK = 'richLink',
  TIMEPICKER = 'timePicker',
  OTPMENU = 'otp',
  ORCA_PAYMENT = 'orca_payment',
  OAUTH = 'authenticate',
  IMESSAGE = 'iMessage',
  LOCATION = 'location',
  CHAT2PAY = 'chat2pay',
  DYNAMICLIST = 'dynamicList',
  MULTI_PRODUCT = 'multiProduct',
  MENUFORM = 'menuForm',
  CONTACTRECEIVING = 'contactReceiving',
  CONTACTSENDING = 'contactSending',
  AIASSISTANT='aiAssistant'
}
